// extracted by mini-css-extract-plugin
module.exports = {"root":"TermsView_root__2I5Ct","signed":"TermsView_signed__1TgxZ"};